import React from "react"
import HelpWidgetChartInteractiveMolecule from "views/molecules/interactive/HelpWidgetChartInteractiveMolecule"
import { Radar } from "react-chartjs-2"
import { DEFAULT_OPTIONS } from "services/charts/default"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"
import className from "classnames"
import Colors from "assets/configs/score"
import { HIDDEN_LEGEND } from "services/charts/legend"

const NON_AUTOMATABLE_CATEGORIES = new Set(["consultation"])

const ChartAnalyzeWebsiteAccessibilityCompliance = ({ websiteScore }) => {
  const { t } = useTranslation()

  const { label_keys, data } = websiteScore.spider_accessibility_categories

  if (!label_keys.length) return null

  const generateData = () => {
    const labels = label_keys.map((label_key) =>
      t(`analyze:websites.accessibility_compliance_level.labels.${label_key}`)
    )
    return {
      labels,
      datasets: [
        {
          label: t("analyze:websites.accessibility_compliance_level.title"),
          data: [...data],
          dataLabels: labels,
          backgroundColor: Colors.common.colors[0],
          hideDatalabelContent: true,
        },
      ],
    }
  }

  return (
    <HelpWidgetChartInteractiveMolecule
      text={t("analyze:websites.accessibility_compliance_level.help")}
    >
      <div
        className={className("Verdikt-Score-DoughnutChart", "environmental")}
      >
        <h1>{t("analyze:websites.accessibility_compliance_level.title")}</h1>
        <div className="content">
          <Radar
            data={generateData()}
            options={{
              ...DEFAULT_OPTIONS,
              legend: HIDDEN_LEGEND,
              tooltips: {
                callbacks: {
                  title: (items, dataObj) =>
                    items.length ? dataObj.labels[items[0].index] : "",
                  label: (item, dataObj) => {
                    const ds = dataObj.datasets[item.datasetIndex]
                    const categoryKey = label_keys[item.index]
                    if (NON_AUTOMATABLE_CATEGORIES.has(categoryKey)) {
                      return t(
                        "analyze:websites.accessibility_compliance_level.no_automation_tooltip"
                      )
                    }
                    return `${ds.label}: ${item.value}%`
                  },
                },
              },
              scale: {
                ticks: {
                  suggestedMax: 100,
                  callback: (value) => `${value} %`,
                },
              },
            }}
          />
        </div>
      </div>
    </HelpWidgetChartInteractiveMolecule>
  )
}

ChartAnalyzeWebsiteAccessibilityCompliance.propTypes = {
  websiteScore: PropTypes.object.isRequired,
}

export default ChartAnalyzeWebsiteAccessibilityCompliance
